import TrainTypeReferenceEditor from './train-type-reference-editor';

export default TrainTypeReferenceEditor;